import React from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import { idxMap } from 'helpers/styleMapIdx';

import styles from './SortButton.module.scss';

const VARIANTS = {
  active: styles.active,
};

const SortButton = ({
  variant,
  text,
  startIcon,
  ...restProps
}: { variant: any; text: any; startIcon: any } & Record<string, any>) => (
  <button
    {...restProps}
    className={cn(
      styles.sortButton,
      idxMap(VARIANTS as Record<string, string>, variant),
    )}
  >
    <>
      {startIcon && <span className={styles.startIcon}>{startIcon}</span>}
      <Typography variant="body2" mode="compact" weight="medium">
        {text}
      </Typography>
    </>
  </button>
);

export default React.memo(SortButton) as any;
